import { Text, TextProps } from '@chakra-ui/react';

const Description = ({ children, ...props }: TextProps) => (
  <Text
    fontSize={{ base: '14px', lg: '16px' }}
    fontWeight="normal"
    fontFamily="Monorale"
    color="midnightBlueDark"
    lineHeight={{ lg: '26px' }}
    {...props}
  >
    {children}
  </Text>
);

export default Description;
